'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { fontsLoaded as areFontsLoaded, fontsLoadedPromise, iconFontsLoaded as areIconFontsLoaded, iconFontsLoadedPromise } from 'UIComponents/utils/Fonts';
class WaitUntilFontsAndIconsAreLoaded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontsLoaded: areFontsLoaded(),
      iconFontsLoaded: areIconFontsLoaded()
    };
  }
  componentDidMount() {
    const {
      timeoutOverride,
      iconFontsLoadedPromiseOverride,
      fontsLoadedPromiseOverride
    } = this.props;
    this._isMounted = true;
    if (!areIconFontsLoaded()) {
      iconFontsLoadedPromiseOverride.then(() => {
        if (this._isMounted) {
          this.setState({
            iconFontsLoaded: true
          });
        }
      }).catch(() => {
        this.setState({
          iconFontsLoaded: false
        });
      });
    }
    if (!areFontsLoaded()) {
      fontsLoadedPromiseOverride.then(() => {
        if (this._isMounted) {
          this.setState({
            fontsLoaded: true
          });
        }
      }).catch(() => {
        this.setState({
          fontsLoaded: false
        });
      });
    }

    // Fallback incase the fonts don't load, if after 5 seconds the font promise doesn't resolve
    // just mount the downstream components (dnd area toolbars) so atleast _something_ displays / functions
    // for users, even if it doesn't look quite right due to missing fonts. Only do this if this component is still mounted
    // (it will get unmounted once measurements are actually taken)
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({
          iconFontsLoaded: true,
          fontsLoaded: true
        });
      }
    }, timeoutOverride);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const {
      children
    } = this.props;
    const {
      fontsLoaded,
      iconFontsLoaded
    } = this.state;
    if (!fontsLoaded || !iconFontsLoaded) {
      return null;
    }
    return children;
  }
}
WaitUntilFontsAndIconsAreLoaded.propTypes = {
  children: PropTypes.node.isRequired,
  fontsLoadedPromiseOverride: PropTypes.shape({
    then: PropTypes.func.isRequired,
    catch: PropTypes.func.isRequired
  }),
  iconFontsLoadedPromiseOverride: PropTypes.shape({
    then: PropTypes.func.isRequired,
    catch: PropTypes.func.isRequired
  }),
  timeoutOverride: PropTypes.number
};
WaitUntilFontsAndIconsAreLoaded.defaultProps = {
  fontsLoadedPromiseOverride: fontsLoadedPromise,
  iconFontsLoadedPromiseOverride: iconFontsLoadedPromise,
  timeoutOverride: 5000
};
export default WaitUntilFontsAndIconsAreLoaded;